import { Button } from "@chakra-ui/react";
import { ArrowUpIcon } from "@chakra-ui/icons";
import { useNavigate, useParams } from "react-router-dom";

export default function ReturnTopButton() {
  const navigate = useNavigate();
  const { year } = useParams();

  const goToTopPage = () => {
    navigate(`/${year}`);
  };

  return (
    <Button
      leftIcon={<ArrowUpIcon />}
      colorScheme="teal"
      variant="solid"
      onClick={goToTopPage}
    >
      Return To Top Page
    </Button>
  );
}